import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";

const PageShell = ({ children, className = "", forceSiteChrome = false }) => {
  const { pathname, hash } = useLocation();
  const companionAppRoute = pathname === "/app" || pathname.startsWith("/app/");
  const focusedAssessmentRoute = pathname === "/assessment/start" || pathname.startsWith("/assessment/start/");
  const hideSiteChrome = (companionAppRoute || focusedAssessmentRoute) && !forceSiteChrome;

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "auto", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname, hash]);

  return (
    <main
      data-testid="page-shell"
      className={`relative min-h-screen forr-canvas forr-text-ink overflow-x-hidden ${className}`}
    >
      <div className="forr-grain" aria-hidden="true" />
      {!hideSiteChrome && <Header />}
      <div className={hideSiteChrome ? "" : "pt-20"}>{children}</div>
      {!hideSiteChrome && <Footer />}
    </main>
  );
};

export default PageShell;
